module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAOtJREFUOBFjYKAQKHT/bWCkxAyQAf//M9STbQjMAJAjyDIE2QCyDEE3gGRDsBlAkiG4DCDaEHwGgAxhBhH4AD4DIvQYGUS5GRmYyDUg05yRocyOkeHnHwYGFlyGwFwgxAlMB8CE8PYbRCUoTVQ5MDL4aDAyJK79x3DxOQ7vwAwAafMGKp7kw8TwBmjIk08MDB3ujAxWcowMCUADbrxGGAxhQUlkA0BCIJu91CFOB7FBhmVu/Mfw8gtIFgJA4nCAbgBcAsgQ52FgSDBiZJhx6j/Dxx/IMkjJHp8BqFoweWCXUGIAyEhGSg0AGQIA1EltfNeHutkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/member/icon_xuanzhong.png
// module id = vxYf
// module chunks = 2